import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Project } from '@src/app/models/project';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Customer } from '../model/customer';
import { Organization } from '@src/app/models/organization';
import { Customerdeal } from '@src/app/models/customerdeal';

@Injectable({
  providedIn: 'root'
})
export class ProjectaddService {

  serviceUrl:string = environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project';
  customerUrl:string = environment.apiUrl+'/organization/';
  constructor(private http:HttpClient) { }

  createProject(project:Project){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post<any>(this.serviceUrl,project,httpOptions)
  }
  // getCustomers(){
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json'
  //     })
  //   }
  //   ///organization/{organizationId}/customer/list/pit/{pitdate}
  //   return this.http.get<Customer[]>(this.customerUrl+SessionHelper.getChoosenOrg()+"/customer/list/pit/"+ new Date().toISOString(),httpOptions);
  // }

  getOrg(){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    ///organization/{organizationId}
    return this.http.get<Organization>(this.customerUrl+SessionHelper.getChoosenOrg(),httpOptions);
  }

    //get deals for customer
    getDeals(customerId,pit){
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
      //GET	    /organization/{organizationId}/customer/{customerId}/deal/list/pit/{pitdate}
      return this.http.get<Customerdeal[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customerId+'/deal/list/pit/'+pit,httpOptions);
   
    }
}
